<template>
    <div>

    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>

        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                    <v-row>
                        <v-col cols="12" sm="6" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="this.$t('alleissocso.socsoandeissubmissioncode')"
                                type="text"
                                :rules="[rules.required]"
                                v-model="formData.eissocsubreccode"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.description')"
                                type="text"
                                :rules="[rules.required]"
                                v-model="formData.eissocsubrecdesc"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="3" class="pb-n5 mt-n8">
                            <v-autocomplete
                                clearable
                                outlined
                                :label="this.$t('reportsparam.year')"
                                v-model="formData.recyear"
                                @change="changeYearHandler(formData.recyear)"
                                @input="updateValue"
                                dense
                                :items="yearList"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="3" class="pb-n5 mt-n8">
                            <v-autocomplete
                                clearable
                                outlined
                                :label="this.$t('reportsparam.month')"
                                v-model="formData.recmonth"
                                @change="changeMonthHandler(formData.recmonth)"
                                @input="updateValue"
                                dense
                                :items="monthList"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="1" sm="1" class="pb-n5 mt-n7">
                            <v-btn icon color="orange">
                                <v-icon @click="loadPayoutList()">mdi-refresh</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="blue--text">
                            {{$t('statutoryexportcommonused.payouts')}}
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-data-table
                            :headers="dataHeader"
                            :items="this.dataItems"
                            :options="tableOpt"
                            hide-default-footer
                            :single-select="singleSelect"
                            item-key="payoutcode"
                            show-select
                            @input="changePayoutHandler()"                           
                            v-model="selected"
                        >
                        </v-data-table>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="blue--text mt-6">
                            {{$t('recworkflowmaintenance.approvaldetail')}}
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="this.$t('statutoryexportcommonused.fullname')"
                                type="text"
                                v-model="formData.aprname"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('statutoryexportcommonused.icno')"
                                type="text"
                                v-model="formData.apricno"
                                @input="updateValue"
                                dense
                                
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('statutoryexportcommonused.designation')"
                                type="text"
                                v-model="formData.aprdesignation"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.email')"
                                type="text"
                                v-model="formData.apremail"
                                @input="updateValue"
                                dense
                                :rules="[rules.email]"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('statutoryexportcommonused.telno')"
                                type="text"
                                v-model="formData.aprtel"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="blue--text">
                            {{$t('statutoryexportcommonused.referencenumberandpaymentinfo')}}
                        </v-col>
                    </v-row>

                    <v-row>
                        <app-table 
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                detailItem: this.formData.eissocsosubrecref
                            }"

                            v-on:input="addItemHandler"
                        />

                    </v-row>

                </v-container>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" />

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
        Loading,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('reportsparam.invalidemail')
                    }
            },

            formData: {
                eissocsubreccode:  this.parentObject.data.eissocsubreccode,
                eissocsubrecdesc: this.parentObject.data.eissocsubrecdesc,
                eissocsosubrecpay: this.parentObject.data.eissocsosubrecpay,
                eissocsosubrecref: this.parentObject.data.eissocsosubrecref,
                recyear:  this.parentObject.data.recyear,
                recmonth:    this.parentObject.data.recmonth,
                aprname:    this.parentObject.data.aprname,
                apricno:    this.parentObject.data.apricno,
                aprdesignation:    this.parentObject.data.aprdesignation,
                apremail:    this.parentObject.data.apremail,
                aprtel:    this.parentObject.data.aprtel,
                stamp:      this.parentObject.data.stamp,
                userid:     this.parentObject.data.userid
            },

            singleSelect: false,
            dataItems: [],
            dataHeader: [
                { text: this.$t('statutoryexportcommonused.Payout'),            value: 'payoutcode',    width: '150px', sortable: true},
                { text: this.$t('statutoryexportcommonused.payoutdescription'),   value: 'payoutdesc',    width: '300px', sortable: true},
                { text: this.$t('payrollprocessrun.payoutstatus'),        value: 'pystatusdesc',  width: '300px', sortable: true}
            ],

            tableOpt: {
                itemsPerPage: -1
            },

            //not sure what this does
            selected: [],
            affectItems: [],

            tabHeader: [
                { text: this.$t('columns.actions'),       value: 'action',    width: '100px', sortable: false},
                { text: this.$t('alleissocso.socsorefnocode'), value: 'socsorefcode',          width: '170px', sortable: true},
                { text: this.$t('alleissocso.eisrefnocode'), value: 'eisrefcode',          width: '150px', sortable: true},
                { text: this.$t('recfamdetails.refno'),value: 'refnum',          width: '150px', sortable: true},
                { text: this.$t('claimrecordlisting.receiptno'),  value: 'receiptno',          width: '150px', sortable: true},
                { text: this.$t('claimrecordlisting.receiptdate'), value: 'receiptdate',          width: '150px', sortable: true},
                { text: this.$t('statutoryexportcommonused.receiptref'),  value: 'receiptref',          width: '150px', sortable: true},
            ],
            
            monthList: [],
            yearList: [],
            payoutList: [],
            months: [],
            years: [],

            loading: false,

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
             search: this.parentObject.searchnew
        }
    },

    methods: {

        loadPayout() {
            const vm = this;

            vm.loading = true;

            this.$store.dispatch('get', {url: '/eissocsopayoutctrlfew/few'})
                .then(res => {
                    vm.payoutList = res.data.rec;

                    vm.loading = false

                    for (let i = 0; i < res.data.rec.length; i++) {
                        if (vm.yearList.indexOf(res.data.rec[i].pyyear) === -1) {
                            vm.yearList.push(res.data.rec[i].pyyear) 
                        }
                        
                        if (vm.monthList.indexOf(res.data.rec[i].pymonth) === -1) {
                            vm.monthList.push(res.data.rec[i].pymonth) 
                        }
                    }

                    this.loadPayoutEdit();

                    if (vm.formData.recyear) {
                        vm.changeYearHandler(vm.formData.recyear);
                    }

                    if (vm.formData.recmonth) {
                        vm.changeMonthHandler(vm.formData.recmonth);
                    }

                    
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        changeYearHandler(id) {
            this.years.find(item => item.id === id);
        },

        changeMonthHandler(id) {
            this.months.find(item => item.id === id);
        },

        changePayoutHandler() {
            this.formData.eissocsosubrecpay = this.selected
            this.updateValue()
        },

        loadPayoutList() {
            let payoutYear = [];
            if (!this.formData.recyear && !this.formData.recmonth) {
                this.dataItems = this.payoutList
            } else if (this.formData.recyear) {
                for (let i = 0; i < this.payoutList.length; i++) {
                    if (this.payoutList[i].pyyear === this.formData.recyear) {
                        payoutYear.push(this.payoutList[i])
                    }
                }
                if (this.formData.recmonth) {
                    this.dataItems = []
                    for (let j = 0; j < payoutYear.length; j++) {
                        if (payoutYear[j].pymonth === this.formData.recmonth) {
                            this.dataItems.push(payoutYear[j])
                        }
                    }
                }
            }
        },

        loadPayoutEdit() {
            let getItem = []
            if (this.isEdit) {
                for (let i = 0; i < this.payoutList.length; i++) {
                    for (let j = 0; j < this.formData.eissocsosubrecpay.length; j++) {
                        if (this.payoutList[i].pyctrlid === this.formData.eissocsosubrecpay[j].pyctrlid) {
                            getItem[j] = this.payoutList[i]
                            getItem[j].exId = this.formData.eissocsosubrecpay[j].id
                            
                        }
                    }
                }
                
                this.loadPayoutList()
                this.selected = getItem
                this.formData.eissocsosubrecpay = []
            }
        },

        addItemHandler($event) {
            this.formData.eissocsosubrecref=$event

            this.updateValue();
        },

        updateValue() {
            this.$emit('input', {
                eissocsubreccode: this.formData.eissocsubreccode,
                eissocsubrecdesc: this.formData.eissocsubrecdesc,
                recyear: this.formData.recyear,
                recmonth: this.formData.recmonth,
                aprname: this.formData.aprname,
                apricno: this.formData.apricno,
                aprdesignation: this.formData.aprdesignation,
                apremail: this.formData.apremail,
                aprtel: this.formData.aprtel,
                eissocsosubrecpay: this.formData.eissocsosubrecpay,
                eissocsosubrecref: this.formData.eissocsosubrecref,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'eissocsublist', params: { search: this.search}});
        },

    },

    mounted() {
        this.loadPayout();
    }
}
</script>